import EventEmitter from 'events'
import SocketService from './SocketService.js'
import { getCurrentModuleName, createPromise } from './utils.js'

class ModuleService extends EventEmitter {
  constructor () {
    super()
    this._moduleConfig = {}
    this._moduleData = {}
    SocketService.on('danmaku.module.updateModuleConfig', data => {
      if (data.module === getCurrentModuleName()) {
        this.emit('updateModuleConfig', data.config)
      }
    })
    SocketService.on('danmaku.module.updateModuleData', data => {
      if (data.module === getCurrentModuleName()) {
        this.emit('updateModuleData', data.data)
      }
    })
  }

  getCurrentModuleName () {
    return getCurrentModuleName()
  }

  getModuleManifest () {
    let moduleName = getCurrentModuleName()
    if (moduleName) {
      return createPromise({
        event: 'danmaku.module.getModuleManifest',
        data: {
          moduleName
        }
      })
    } else {
      return Promise.reject(new Error('[Module Service] Could not get module name'))
    }
  }

  fetchModuleConfig () {
    return createPromise({
      event: 'danmaku.module.getModuleConfig',
      data: {
        moduleName: getCurrentModuleName()
      }
    }).then(data => {
      this._moduleConfig = data
    })
  }

  getModuleConfig (defaultConfig) {
    return Object.assign({}, defaultConfig, this._moduleConfig)
  }

  fetchModuleData () {
    return createPromise({
      event: 'danmaku.module.getModuleData',
      data: {
        moduleName: getCurrentModuleName()
      }
    }).then(data => {
      this._moduleData = data
    })
  }

  getModuleData (defaultData) {
    return Object.assign({}, defaultData, this._moduleData)
  }
}

export default new ModuleService()



// WEBPACK FOOTER //
// ./src/container/Module.js